__turbopack_context__.v({
  "large": "GuideTitle-module-scss-module__LF1H1G__large",
  "medium": "GuideTitle-module-scss-module__LF1H1G__medium",
  "small": "GuideTitle-module-scss-module__LF1H1G__small",
});
